module.exports = __webpack_public_path__ + "media/application/images/ui/email-top-dea71dccc78f43f11f3a7fed5f88e41a.gif";